import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const MyTopologies = lazy(() => import("./MyTopologies/MyTopologies"));
const QueueRequests = lazy(() => import("./QueueRequests/QueueRequests"));
const AvailableTopologies = lazy(() => import("./NewTopology/AvailableTopologies"));
const TopologyDetailsWrapper = lazy(() => import("./TopologyDetails/TopologyDetailsWrapper"));
const ResourceLinks = lazy(() => import("./ResourceLinks"));
const Support = lazy(() => import("./Support"));
const CloudInfo = lazy(() => import("./CloudInfo"));

function Router() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <Route path="/MyTopologies" component={MyTopologies} />
        <Route path="/QueueRequests" component={QueueRequests} />
        <Route path="/NewTopology" component={AvailableTopologies} />
        <Route path="/TopologyDetails/:topoId?" component={TopologyDetailsWrapper} />
        <Route path="/ResourceLinks" component={ResourceLinks} />
        <Route path="/Support" component={Support} />
        <Route path="/CloudInfo" component={CloudInfo} />
        <Redirect from="*" to={"/MyTopologies"} />
      </Switch>
    </Suspense>
  );
}

export default Router;
